<rk-fold-item [name]="'MEDIA.FILTERS.TAG_INPUT.HEADER' | translate">
  <ng-container [formGroup]="tagsForm">
    <mat-radio-group rkInput formControlName="operator">
      <div>
        <div>
          <mat-radio-button value="all">{{
            'MEDIA.FILTERS.TAG_INPUT.ALL' | translate
          }}</mat-radio-button>
        </div>
        <mat-radio-button value="match_one">{{
          'MEDIA.FILTERS.TAG_INPUT.MATCH_ONE' | translate
        }}</mat-radio-button>
        <rk-chips-input
          [@slideInOutBlock]
          *ngIf="tagsForm.value['operator'] === 'match_one'"
          formControlName="value"
          [dataFetched]="tags$ | async"
          [canAddNew]="false"
          [chipMaxLength]="255"
          [placeholder]="'MEDIA.FILTERS.TAG_INPUT.PLACEHOLDER' | translate"
        ></rk-chips-input>
      </div>
      <div>
        <mat-radio-button value="match_all">{{
          'MEDIA.FILTERS.TAG_INPUT.MATCH_ALL' | translate
        }}</mat-radio-button>
        <rk-chips-input
          [@slideInOutBlock]
          *ngIf="tagsForm.value['operator'] === 'match_all'"
          formControlName="value"
          [dataFetched]="tags$ | async"
          [canAddNew]="false"
          [chipMaxLength]="255"
          [placeholder]="'MEDIA.FILTERS.TAG_INPUT.PLACEHOLDER' | translate"
        ></rk-chips-input>
      </div>
      <div>
        <mat-radio-button value="not_set">{{
          'MEDIA.FILTERS.TAG_INPUT.NOT_SET' | translate
        }}</mat-radio-button>
      </div>
    </mat-radio-group>
  </ng-container>
</rk-fold-item>
